const alphaBlogs = [
    {
        title: '12/22/25',
        fileName: 'week0.md',
        id: 'week0-blog'
    },
    {
        title: '12/29/25',
        fileName: 'week1.md',
        id: 'week1-blog'
    },
    {
        title: '01/05/26',
        fileName: 'week2.md',
        id: 'week2-blog'
    },
    {
        title: '01/12/26',
        fileName: 'week3.md',
        id: 'week3-blog'
    },
    {
        title: '01/19/26',
        fileName: 'week4.md',
        id: 'week4-blog'
    },
    {
        title: '01/26/26',
        fileName: 'week5.md',
        id: 'week5-blog'
    },
    {
        title: '02/02/26',
        fileName: 'week6.md',
        id: 'week6-blog'
    },
    {
        title: '02/09/26',
        fileName: 'week7.md',
        id: 'week7-blog'
    },
    {
        title: '02/16/26',
        fileName: 'week8.md',
        id: 'week8-blog'
    },
    {
        title: '02/23/26',
        fileName: 'week9.md',
        id: 'week9-blog'
    },
    {
        title: '03/02/26',
        fileName: 'week10.md',
        id: 'week10-blog'
    },
    {
        title: '03/09/26',
        fileName: 'week11.md',
        id: 'week11-blog'
    },
    {
        title: '03/16/26',
        fileName: 'week12.md',
        id: 'week12-blog'
    },
    {
        title: '03/23/26',
        fileName: 'week13.md',
        id: 'week13-blog'
    },
    {
        title: '03/30/26',
        fileName: 'week14.md',
        id: 'week14-blog'
    },
    {
        title: '04/06/26',
        fileName: 'week15.md',
        id: 'week15-blog'
    },
    {
        title: '04/13/26',
        fileName: 'week16.md',
        id: 'week16-blog'
    },
    {
        title: '04/20/26',
        fileName: 'week17.md',
        id: 'week17-blog'
    },
    {
        title: '04/27/26',
        fileName: 'week18.md',
        id: 'week18-blog'
    },
    {
        title: '05/04/26',
        fileName: 'week19.md',
        id: 'week19-blog'
    },
    {
        title: '05/11/26',
        fileName: 'week20.md',
        id: 'week20-blog'
    },
    {
        title: '05/18/26',
        fileName: 'week21.md',
        id: 'week21-blog'
    },
    {
        title: '05/25/26',
        fileName: 'week22.md',
        id: 'week22-blog'
    },
    {
        title: '06/01/26',
        fileName: 'week23.md',
        id: 'week23-blog'
    },
    {
        title: '06/08/26',
        fileName: 'week24.md',
        id: 'week24-blog'
    },
    {
        title: '06/15/26',
        fileName: 'week25.md',
        id: 'week25-blog'
    },
    {
        title: '06/22/26',
        fileName: 'week26.md',
        id: 'week26-blog'
    },
    {
        title: '06/29/26',
        fileName: 'week27.md',
        id: 'week27-blog'
    },
    {
        title: '07/06/26',
        fileName: 'week28.md',
        id: 'week28-blog'
    },
    {
        title: '07/13/26',
        fileName: 'week29.md',
        id: 'week29-blog'
    },
    {
        title: '07/20/26',
        fileName: 'week30.md',
        id: 'week30-blog'
    },
    {
        title: '07/27/26',
        fileName: 'week31.md',
        id: 'week31-blog'
    },
    {
        title: '08/03/26',
        fileName: 'week32.md',
        id: 'week32-blog'
    },
    {
        title: '08/10/26',
        fileName: 'week33.md',
        id: 'week33-blog'
    },
    {
        title: '08/17/26',
        fileName: 'week34.md',
        id: 'week34-blog'
    },
    {
        title: '08/24/26',
        fileName: 'week35.md',
        id: 'week35-blog'
    },
    {
        title: '08/31/26',
        fileName: 'week36.md',
        id: 'week36-blog'
    },
    {
        title: '09/07/26',
        fileName: 'week37.md',
        id: 'week37-blog'
    },
    {
        title: '09/14/26',
        fileName: 'week38.md',
        id: 'week38-blog'
    },
    {
        title: '09/21/26',
        fileName: 'week39.md',
        id: 'week39-blog'
    },
    {
        title: '09/28/26',
        fileName: 'week40.md',
        id: 'week40-blog'
    },
    {
        title: '10/05/26',
        fileName: 'week41.md',
        id: 'week41-blog'
    },
    {
        title: '10/12/26',
        fileName: 'week42.md',
        id: 'week42-blog'
    },
    {
        title: '10/19/26',
        fileName: 'week43.md',
        id: 'week43-blog'
    },
    {
        title: '10/26/26',
        fileName: 'week44.md',
        id: 'week44-blog'
    }
];

export default alphaBlogs;